import {meetActionTypes} from '../action/action';

interface verificationState {
verifyReqModal:boolean;
imgCount:number;
verifyModalEnable:boolean;
imgFile:any;
isFace:boolean;
isDocs:boolean;
isFaceDocs:boolean;
isStore:boolean;
isVerify:boolean;
verifyAcceptModal:boolean;
declineModal:boolean;
faceRecogModal:boolean;
verifyErrMsg:string;
verifySuccessMsg:string;
faceImgUrl:any;
docImgUrl:any;
dataProcessing:boolean;
verifyContent:string;
verifyAttachments:any;
docModal:boolean;
docSendDetails:any;
docReceiveDetails:any;
docCaptureModal:boolean;
docDetailsModal:boolean;
faceCaptureModal:boolean;

}
const initialState = {
verifyReqModal:false,
verifyModalEnable:false,
imgCount:0,
imgFile:{file1:"",file2:"",file3:"",file4:"",file5:""},
isFace:true,
isDocs:false,
isFaceDocs:false,
isStore:false,
isVerify:false,
verifyAcceptModal:false,
declineModal:false,
faceRecogModal:false,
verifyErrMsg:"",
verifySuccessMsg:"",
faceImgUrl:"",
docImgUrl:"",
dataProcessing:false,
verifyContent:"",
verifyAttachments:null,
docModal:false,
docSendDetails:{},
docReceiveDetails:{},
docCaptureModal:false,
docDetailsModal:false,
faceCaptureModal:false
};

export const verificationReducer = (state:verificationState  = initialState, action: any) => {
  const {
    type,
    payload
  } = action;
  switch (type) {
  case meetActionTypes.VERIFICATION_MODAL:
    return {
      ...state, verifyReqModal: payload.verifyReqModal,verifyModalEnable:payload.verifyModalEnable,verifyAcceptModal:payload.verifyAcceptModal,declineModal:payload.declineModal,faceRecogModal:payload.faceRecogModal,faceCaptureModal:payload.faceCaptureModal
    };
  case meetActionTypes.FACE_VERIFICATION_DETAILS:
    return {
      ...state,isStore:payload.isStore,isVerify:payload.isVerify,isFace:payload.isFace,isDocs:payload.isDocs,isFaceDocs:payload.isFaceDocs
    };
  case meetActionTypes.FACE_VERIFICATION_IMG_INFO:
    return {
      ...state,imgCount: payload.imgCount,imgFile:payload.imgFile,faceImgUrl:payload.faceImgUrl,docImgUrl:payload.docImgUrl
    };
  case meetActionTypes.VERFICATION_MSG:
    return {
      ...state,verifyErrMsg:payload.verifyErrMsg,verifySuccessMsg:payload.verifySuccessMsg,dataProcessing:payload.dataProcessing,verifyContent:payload.verifyContent
    };
  case meetActionTypes.VERIFICATION_ATTACHMENTS:
    return {
      ...state,verifyAttachments:payload.verifyAttachments
    };
  case meetActionTypes.DOC_MODAL:
    return {
      ...state,docModal:payload.docModal,docSendDetails:payload.docSendDetails,docReceiveDetails:payload.docReceiveDetails,docCaptureModal:payload.docCaptureModal,docDetailsModal:payload.docDetailsModal
    };
  default:
    return state;
  };
};
